"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MathUtil_1 = require("./MathUtil");
class ImmutablePrioritySet extends Set {
    constructor(_values) {
        super(_values);
        this._values = _values;
    }
    static of(values) {
        return new ImmutablePrioritySet(values);
    }
    compare(a, b) {
        if (!this.has(a) || !this.has(b)) {
            throw new Error("No such element");
        }
        return MathUtil_1.default.compare(this._values.indexOf(a), this._values.indexOf(b));
    }
    iterator() {
        return this[Symbol.iterator]();
    }
}
exports.default = ImmutablePrioritySet;
